import React, { createContext, useContext } from 'react';

export const ColorModeContext = createContext({
  mode: 'light',
  setMode: () => {},
  toggleColorMode: () => {}
});

export const useColorMode = () => useContext(ColorModeContext);
